import * as React from 'react'

import MatchTeamView from './MatchTeamView'
import PlayButtonView from './PlayButtonView'
import LiveScoreSubtitleView from './LiveScoreSubtitleView'
import { getFlagUrl } from '../../api/assetUrls';

import('./LiveScoreStyles.scss')   


const LiveScorePresentation = (props:any) => {

    return (
        <div className="LivescoreNew"
             onClick={ ( event: any ) => { props.deactivateClickHandler == 'true' || props.changeChannel( props.channelId )  } }>

            <PlayButtonView active={ props.active } />

            <div className="livescoreMatch">
                <MatchTeamView homeOrAway={ 'home' }
                               periodScores={ props.periodScores }
                               ranks={ props.ranks }
                               ranksByPlayerIds={ props.ranksByPlayerIds }
                               playerUid={props.playerUids['home']}
                               playerNames={ props.playerNames }
                               servingPlayer={ props.servingPlayer }
                               gamePoints={ props.gamePoints }
                               flagUrl={ getFlagUrl( props.baseUrl, props.clientid, props.playerids['home'] ) }
                               period={ props.period }
                               playerAbbreviationNames={ props.playerAbbreviationNames }/>

                <MatchTeamView homeOrAway={ 'away' }
                               periodScores={ props.periodScores }
                               ranks={ props.ranks }
                               ranksByPlayerIds={ props.ranksByPlayerIds }
                               playerUid={props.playerUids['away']}
                               playerNames={ props.playerNames }
                               servingPlayer={ props.servingPlayer }
                               gamePoints={ props.gamePoints }
                               flagUrl={ getFlagUrl( props.baseUrl, props.clientid, props.playerids['away'] ) }
                               period={ props.period }
                               playerAbbreviationNames={ props.playerAbbreviationNames }/>
            </div>

            <LiveScoreSubtitleView nthPointCounter={ props.gamePoints.nthPointCounter }
                                   nthGameCounterOfSet={ props.gameScore.nthGameCounterOfSet }
                                   period={ props.period }
                                   pointflagStaticTextKey={ props.pointflagStaticTextKey }
                                   pointflagSuffix={ props.pointflagSuffix }
                                   staticTexts={props.staticTexts}
                                   translations={props.translations}
                                   playerAbbreviationNames={ props.playerAbbreviationNames }
                                   phase={ props.activePhaseId }
                                   team={ props.gameScore.team }/>
        </div>
    )
}

export default LiveScorePresentation
